module.exports = __webpack_public_path__ + "static/media/quotes.a6a27e1f.svg";